(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orthopedic-buy-box"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initShpb(root) {
      if (!root || root.dataset.ready === '1') return;
      root.dataset.ready = '1';

      var product = JSON.parse(root.querySelector('[data-shpb-product]').textContent);
      var cfg = JSON.parse(root.querySelector('[data-shpb-config]').textContent);
      var variants = product.variants;
      var form = root.querySelector('form.shpb__form');
      var idInput = root.querySelector('[data-shpb-id]');
      var atc = root.querySelector('[data-shpb-atc]');
      var atcLabel = root.querySelector('[data-atc-label]');
      var errorEl = root.querySelector('[data-shpb-error]');
      var current = variants.find(function (v) { return String(v.id) === String(idInput.value); }) || variants[0];
      var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function money(cents) {
        var n = (cents || 0) / 100;
        function fmt(dec, th, ds) { var p = n.toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p.join(ds); }
        var map = {
          amount: fmt(2, ',', '.'), amount_no_decimals: fmt(0, ',', '.'),
          amount_with_comma_separator: fmt(2, '.', ','), amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
          amount_with_space_separator: fmt(2, ' ', ','), amount_with_period_and_space_separator: fmt(2, ' ', '.')
        };
        if (!cfg.moneyFormat) return 'R ' + map.amount;
        return cfg.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) { return map[k] || map.amount; });
      }
      function moneyShort(cents) { return money(cents).replace(/[.,]00(?=\D*$)/, ''); }
      function findVariant(opts) { return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }); }
      function qtyOf(value) { var n = parseInt(value, 10); return n > 0 ? n : 1; }
      function setError(msg) { errorEl.textContent = msg || ''; errorEl.hidden = !msg; }

      /* ---------- gallery ---------- */
      var gallery = { goToId: function () {} };
      var track = root.querySelector('[data-track]');
      if (track && track.children.length) {
        var slides = Array.prototype.slice.call(track.children);
        var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('.shpb__dots span'));
        var prev = root.querySelector('[data-prev]'), next = root.querySelector('[data-next]');
        var idx = -1, raf;
        var go = function (i, smooth) {
          i = Math.max(0, Math.min(slides.length - 1, i));
          track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false || reduce ? 'auto' : 'smooth' });
        };
        var setActive = function (i) {
          if (i === idx) return; idx = i;
          thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === i ? 'true' : 'false'); });
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          if (prev) prev.disabled = i === 0;
          if (next) next.disabled = i === slides.length - 1;
          slides.forEach(function (s, n) { var vid = s.querySelector('video'); if (n !== i && vid && !vid.paused) vid.pause(); });
        };
        track.addEventListener('scroll', function () {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
        }, { passive: true });
        thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
        if (prev) prev.addEventListener('click', function () { go(idx - 1); });
        if (next) next.addEventListener('click', function () { go(idx + 1); });
        track.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
          if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        });
        gallery.goToId = function (id, smooth) {
          var n = slides.findIndex(function (s) { return s.dataset.mediaId === String(id); });
          if (n > -1) go(n, smooth);
        };
        setActive(0);
        if (current.featured_media) gallery.goToId(current.featured_media.id, false);
      }

      /* ---------- variants ---------- */
      function render(v, fromUser) {
        current = v;
        idInput.value = v.id;
        idInput.setAttribute('value', v.id);

        root.querySelectorAll('[data-option-index]').forEach(function (fs) {
          var i = Number(fs.dataset.optionIndex);
          fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
            r.checked = r.value === v.options[i];
            var label = r.closest('label');
            if (!label) return;
            label.classList.toggle('is-selected', r.checked);
            if (i !== cfg.bundleIndex) {
              var o = v.options.slice(); o[i] = r.value;
              var alt = findVariant(o);
              label.classList.toggle('is-unavailable', !alt || !alt.available);
            }
          });
        });

        root.querySelector('[data-price]').textContent = money(v.price);
        var cmp = root.querySelector('[data-compare]'), save = root.querySelector('[data-save]');
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        cmp.hidden = !onSale; save.hidden = !onSale;
        if (onSale) {
          cmp.textContent = money(v.compare_at_price);
          save.textContent = cfg.strings.save + ' ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }

        if (cfg.bundleIndex > -1) {
          root.querySelectorAll('[data-tier]').forEach(function (t) {
            var o = v.options.slice(); o[cfg.bundleIndex] = t.dataset.tier;
            var tv = findVariant(o);
            if (!tv) return;
            var q = qtyOf(t.dataset.tier);
            var parts = [];
            var tag = tv.compare_at_price > tv.price ? '<span class="shpb__tag">' + cfg.strings.save + ' ' + moneyShort(tv.compare_at_price - tv.price) + '</span>' : '';
            if (q > 1 && cfg.showEach) parts.push(money(Math.round(tv.price / q)) + ' ' + cfg.strings.each);
            if (cfg.freeShipCents > 0 && tv.price >= cfg.freeShipCents) parts.push(cfg.strings.freeDelivery);
            t.querySelector('[data-tier-sub]').innerHTML = tag + parts.join(' · ');
            t.querySelector('[data-tier-price]').textContent = money(tv.price);
            var tc = t.querySelector('[data-tier-compare]');
            tc.hidden = !(tv.compare_at_price > tv.price);
            if (!tc.hidden) tc.textContent = money(tv.compare_at_price);
            t.classList.toggle('is-unavailable', !tv.available);
          });
        }

        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? cfg.strings.add : cfg.strings.soldOut;

        if (fromUser) {
          setError('');
          if (window.history && window.history.replaceState) {
            var u = new URL(window.location.href);
            u.searchParams.set('variant', v.id);
            window.history.replaceState(window.history.state, '', u.toString());
          }
          if (v.featured_media) gallery.goToId(v.featured_media.id);
        }
      }

      function selectOption(index, value) {
        var opts = current.options.slice(); opts[index] = value;
        var v = findVariant(opts)
          || variants.find(function (x) { return x.options[index] === value && x.available; })
          || variants.find(function (x) { return x.options[index] === value; });
        if (v) render(v, true);
      }
      root.addEventListener('change', function (e) {
        var r = e.target;
        if (!r || r.type !== 'radio') return;
        var fs = r.closest('[data-option-index]');
        if (fs) selectOption(Number(fs.dataset.optionIndex), r.value);
      });

      /* ---------- size guide ---------- */
      var dlg = root.querySelector('[data-size-dlg]');
      var openBtn = root.querySelector('[data-size-open]');
      if (dlg && openBtn) {
        openBtn.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
        dlg.querySelector('[data-size-close]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }

      /* ---------- fly to cart ---------- */
      function findCartIcon() {
        var sel = ['cart-icon', '.header-actions__cart-icon', 'header a[href$="/cart"]', 'a[href$="/cart"]', '[data-cart-icon]'];
        for (var i = 0; i < sel.length; i++) {
          var els = document.querySelectorAll(sel[i]);
          for (var j = 0; j < els.length; j++) {
            var r = els[j].getBoundingClientRect();
            if (r.width > 0 && r.height > 0) return els[j];
          }
        }
        return null;
      }
      function fly(done) {
        var target = findCartIcon();
        var slide = track ? track.children[Math.max(0, Math.round(track.scrollLeft / Math.max(1, track.clientWidth)))] : null;
        var srcImg = slide && slide.querySelector('img');
        if (reduce || !target || !srcImg || !srcImg.animate) { done(); return; }
        var r = srcImg.getBoundingClientRect(), t = target.getBoundingClientRect();
        var size = Math.min(r.width, 150);
        var el = document.createElement('div');
        el.className = 'shpb-flyer';
        var img = document.createElement('img');
        img.src = srcImg.currentSrc || srcImg.src; img.alt = '';
        el.appendChild(img);
        el.style.width = el.style.height = size + 'px';
        el.style.left = (r.left + r.width / 2 - size / 2) + 'px';
        el.style.top = (r.top + r.height / 2 - size / 2) + 'px';
        document.body.appendChild(el);
        var dx = t.left + t.width / 2 - (r.left + r.width / 2);
        var dy = t.top + t.height / 2 - (r.top + r.height / 2);
        var anim = el.animate([
          { transform: 'translate(0,0) scale(1)', opacity: 1 },
          { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 60) + 'px) scale(.6)', opacity: 1, offset: 0.55 },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: 0.4 }
        ], { duration: 750, easing: 'cubic-bezier(.5,0,.3,1)' });
        anim.onfinish = function () {
          el.remove();
          target.classList.remove('shpb-bump'); void target.offsetWidth; target.classList.add('shpb-bump');
          done();
        };
      }

      /* ---------- cart ---------- */
      function notifyTheme(data, cart) {
        var detail = {
          source: 'sh-product-buy', itemCount: cart.item_count,
          productId: String(product.id), variantId: String(idInput.value),
          sections: (data && data.sections) || {}
        };
        var fallback = function () {
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: root.id, data: detail } }));
        };
        try {
          return import('@theme/events').then(function (m) {
            if (m && m.CartAddEvent) document.dispatchEvent(new m.CartAddEvent({}, root.id, detail));
            else fallback();
          }).catch(fallback);
        } catch (err) { fallback(); return Promise.resolve(); }
      }
      function openDrawer() {
        var drawer = document.querySelector('cart-drawer-component');
        if (!drawer) { window.location.href = shopRoot + 'cart'; return; }
        setTimeout(function () {
          var d = drawer.querySelector('dialog');
          if (d && d.open) return;
          try {
            if (typeof drawer.open === 'function') drawer.open();
            else if (typeof drawer.showDialog === 'function') drawer.showDialog();
          } catch (err) {}
        }, 120);
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (atc.disabled || atc.classList.contains('is-loading')) return;
        setError('');
        atc.classList.add('is-loading');
        atc.setAttribute('aria-busy', 'true');

        var sectionIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map(function (el) { return el.dataset.sectionId; });
        var body = { items: [{ id: Number(idInput.value), quantity: 1 }] };
        if (sectionIds.length) body.sections = sectionIds.join(',');

        fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (res) { return res.json().then(function (d) { if (!res.ok || d.status) throw d; return d; }); })
          .then(function (data) {
            return fetch(shopRoot + 'cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                atc.classList.remove('is-loading');
                atc.classList.add('is-added');
                atcLabel.textContent = cfg.strings.added;
                setTimeout(function () { atc.classList.remove('is-added'); render(current, false); }, 1800);
                fly(function () { notifyTheme(data, cart).then(openDrawer); });
              });
          })
          .catch(function (err) {
            setError((err && (err.description || err.message)) || cfg.strings.error);
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
          });
      });

      /* ---------- reviews link ---------- */
      var rl = root.querySelector('[data-reviews-link]');
      if (rl) {
        rl.addEventListener('click', function (e) {
          e.preventDefault();
          var key = rl.dataset.reviewsTarget;
          var target = key ? document.querySelector('[id*="' + key + '"]') : null;
          if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        });
      }

      /* ---------- delivery estimate ---------- */
      var eta = root.querySelector('[data-eta]');
      if (eta) {
        var addBiz = function (n) {
          var d = new Date(), c = 0;
          while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; }
          return d;
        };
        var fmt = function (d) {
          try { return d.toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' }); }
          catch (e) { return d.toDateString().slice(0, 10); }
        };
        var mn = parseInt(eta.dataset.min, 10), mx = parseInt(eta.dataset.max, 10);
        if (mn > 0 && mx >= mn) {
          eta.querySelector('[data-eta-range]').textContent = 'between ' + fmt(addBiz(mn)) + ' and ' + fmt(addBiz(mx));
        }
      }

      render(current, false);
    }

    function initAll() { document.querySelectorAll('[data-shpb]').forEach(initShpb); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', function (e) { initShpb(e.target.querySelector('[data-shpb]')); });
  })();

  } catch(e) { console.error(e); }
})();
})();
